import { render, staticRenderFns } from "./fold-card.vue?vue&type=template&id=e4b7802e&scoped=true&"
import script from "./fold-card.vue?vue&type=script&lang=js&"
export * from "./fold-card.vue?vue&type=script&lang=js&"
import style0 from "./fold-card.vue?vue&type=style&index=0&id=e4b7802e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4b7802e",
  null
  
)

export default component.exports